const CMS_MODAL_CLASS = 'showSimple';
const SUI_MODAL_CLASS = 'lock-scroll';

const getMutationObserverClass = () =>
    window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

/**
 * Listens to the passed window and calls a function when a modal is opened within the window.
 * @param  {window} iframeWindow
 * @param  {function} onChange     called with a boolean arg for open or closed
 * @return {mutationObserver}
 */
export const bindEventListenerForOpenModals = (iframeWindow, onChange) => {
    const MutationObserver = getMutationObserverClass();
    const iframeBody = iframeWindow.document.body;
    const observerConfig = {
        attributes: true,
        attributeFilter: ['class'],
    };

    // TODO Replace this mutation observation by a subscription to a message sent by the iframe
    const modalObserver = new MutationObserver((mutationList) => {
        const mutation = mutationList[0];

        if (mutation.attributeName === 'class') {
            const { classList } = mutation.target;
            const isModalOpen = classList.contains(CMS_MODAL_CLASS) || classList.contains(SUI_MODAL_CLASS);
            onChange(isModalOpen);
        }
    });

    modalObserver.observe(iframeBody, observerConfig);

    return modalObserver;
};

/**
 * Overwrites the SplashUi 'confirm' and 'hideGrowl' functions to also call the callback function
 * @param  {window} iframeWindow
 * @param  {function} onChange     called with a boolean arg for open or closed
 */
export const overwriteSplashUiForDisplayingModalOverlays = (iframeWindow, onChange) => {
    const { confirm: _confirm, hideGrowl: _hideGrowl, isModalOpen } = iframeWindow.SplashUI;

    // TODO Change this iframe DOM manipulation by a message subscription
    /* eslint-disable no-param-reassign */
    iframeWindow.SplashUI.confirm = (...args) => {
        onChange(true);
        _confirm.apply(iframeWindow.SplashUI, args);
    };

    iframeWindow.SplashUI.hideGrowl = (...args) => {
        if (isModalOpen()) {
            onChange(false);
            _hideGrowl.apply(iframeWindow.SplashUI, args);
        }
    };
    /* eslint-enable */
};
